//////// GHG 3.13 EF
const threeThirteenSchema = {
  title: "3.13 Downstream Leased Assets",
  cat: "5_2",
  catName: "cat5",
  progressiveOrderSwitch: {
    by: { level: 2, key: "assetType5_2" },
  },
  fields: [
    {
      key: "title",
      type: "title",
      title: "Emission Factor",
    },
    //////// Data Source
    {
      key: "emissionFactorTypeId",
      level: 1,
      type: "select",
      label: "Data Source",
      optionsAPI: "emissionFactorDropdown",
      autoFillNum: 0,
    },
    //////// Asset Type
    {
      key: "assetType5_2",
      level: 2,
      type: "select",
      label: "Asset Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        value: "5_2",
      },
      showIf: {
        all: [
          { level: 1, key: "emissionFactorTypeId", ne: "2" },
          { level: 1, key: "emissionFactorTypeId", notEmpty: true },
        ],
      },
      combineKey: 1,
    },
    //////////////// 路徑 1
    {
      key: "sourceEFName5_2",
      level: 4,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 2,
        key: "assetType5_2",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType5_2", eq: "Mobile Gen-Set" },
          { level: 2, key: "assetType5_2", notEmpty: true },
        ],
      },
      combineKey: 2,
    },
    //////// Fuel Type
    {
      key: "fuelType5_2",
      level: 6,
      type: "select",
      label: "Fuel Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 4,
        key: "sourceEFName5_2",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType5_2", eq: "Mobile Gen-Set" },
          { level: 2, key: "assetType5_2", notEmpty: true },
          { level: 4, key: "sourceEFName5_2", notEmpty: true },
        ],
      },
      combineKey: 3,
    },
    //////// Fuel Name
    {
      key: "emissionFactorId",
      level: 7,
      type: "select",
      label: "Fuel Name",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 6,
        key: "fuelType5_2",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType5_2", eq: "Mobile Gen-Set" },
          { level: 2, key: "assetType5_2", notEmpty: true },
          { level: 6, key: "fuelType5_2", notEmpty: true },
        ],
      },
      combineKey: 4,
    },
    //////////////// 路徑2
    //////// Computational Method
    {
      key: "computationMethod5_2",
      level: 3,
      type: "select",
      label: "Computational Method",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 2,
        key: "assetType5_2",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType5_2", eq: "Transport" },
          { level: 2, key: "assetType5_2", notEmpty: true },
        ],
      },
      combineKey: 2,
    },
    //////// Emission Factor Database Source (Fuel Based)
    {
      key: "sourceEFName5_2",
      level: 4,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 3,
        key: "computationMethod5_2",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType5_2", notEmpty: true },
          { level: 2, key: "assetType5_2", eq: "Transport" },
          {
            level: 3,
            key: "computationMethod5_2",
            notEmpty: true,
          },
          {
            level: 3,
            key: "computationMethod5_2",
            eq: "Fuel Based",
          },
        ],
      },
      combineKey: 3,
    },
    //////// Fuel Type (Fuel Based)
    {
      key: "fuelType5_2",
      level: 6,
      type: "select",
      label: "Fuel Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 4,
        key: "sourceEFName5_2",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType5_2", notEmpty: true },
          { level: 2, key: "assetType5_2", eq: "Transport" },
          {
            level: 3,
            key: "computationMethod5_2",
            notEmpty: true,
          },
          {
            level: 3,
            key: "computationMethod5_2",
            eq: "Fuel Based",
          },
          {
            level: 4,
            key: "sourceEFName5_2",
            notEmpty: true,
          },
        ],
      },
      combineKey: 4,
    },
    //////// Fuel Name (Fuel Based)
    {
      key: "emissionFactorId",
      level: 7,
      type: "select",
      label: "Fuel Name",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 6,
        key: "fuelType5_2",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType5_2", notEmpty: true },
          { level: 2, key: "assetType5_2", eq: "Transport" },
          {
            level: 3,
            key: "computationMethod5_2",
            notEmpty: true,
          },
          {
            level: 3,
            key: "computationMethod5_2",
            eq: "Fuel Based",
          },
          {
            level: 6,
            key: "fuelType5_2",
            notEmpty: true,
          },
        ],
      },
      combineKey: 5,
    },
    //////////////// Emission Factor Database Source (Distance Based)
    {
      key: "sourceEFName5_2",
      level: 4,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 3,
        key: "computationMethod5_2",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType5_2", notEmpty: true },
          { level: 2, key: "assetType5_2", eq: "Transport" },
          {
            level: 3,
            key: "computationMethod5_2",
            notEmpty: true,
          },
          {
            level: 3,
            key: "computationMethod5_2",
            eq: "Distance Based",
          },
        ],
      },
      combineKey: 3,
    },
    //////// Transport Model
    {
      key: "transportModel5_2",
      level: 5,
      type: "select",
      label: "Transport Model",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 4,
        key: "sourceEFName5_2",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType5_2", notEmpty: true },
          { level: 2, key: "assetType5_2", eq: "Transport" },
          {
            level: 3,
            key: "computationMethod5_2",
            notEmpty: true,
          },
          {
            level: 3,
            key: "computationMethod5_2",
            eq: "Distance Based",
          },
          {
            level: 4,
            key: "sourceEFName5_2",
            notEmpty: true,
          },
        ],
      },
      combineKey: 4,
    },
    //////// Vehicle Category
    {
      key: "vehicleCategory5_2",
      level: 6,
      type: "select",
      label: "Vehicle Category",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 5,
        key: "transportModel5_2",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType5_2", notEmpty: true },
          { level: 2, key: "assetType5_2", eq: "Transport" },
          {
            level: 3,
            key: "computationMethod5_2",
            notEmpty: true,
          },
          {
            level: 3,
            key: "computationMethod5_2",
            eq: "Distance Based",
          },
          {
            level: 5,
            key: "transportModel5_2",
            notEmpty: true,
          },
        ],
      },
      combineKey: 5,
    },
    //////// Vehicle Type
    {
      key: "emissionFactorId",
      level: 7,
      type: "select",
      label: "Vehicle Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 6,
        key: "vehicleCategory5_2",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType5_2", notEmpty: true },
          { level: 2, key: "assetType5_2", eq: "Transport" },
          {
            level: 3,
            key: "computationMethod5_2",
            notEmpty: true,
          },
          {
            level: 3,
            key: "computationMethod5_2",
            eq: "Distance Based",
          },
          {
            level: 6,
            key: "vehicleCategory5_2",
            notEmpty: true,
          },
        ],
      },
      combineKey: 6,
    },
    //////////////// 路徑3
    {
      key: "emissionSource5_2",
      level: 3,
      type: "select",
      label: "Energy Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 2,
        key: "assetType5_2",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType5_2", eq: "Others" },
          { level: 2, key: "assetType5_2", notEmpty: true },
        ],
      },
      combineKey: 2,
    },
    //////// Emission Factor Database Source (Fuel)
    {
      key: "sourceEFName5_2",
      level: 4,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 3,
        key: "emissionSource5_2",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType5_2", eq: "Others" },
          { level: 2, key: "assetType5_2", notEmpty: true },
          { level: 3, key: "emissionSource5_2", eq: "Fuel" },
          { level: 3, key: "emissionSource5_2", notEmpty: true },
        ],
      },
      combineKey: 3,
    },
    //////// Fuel Type (Fuel)
    {
      key: "fuelType5_2",
      level: 6,
      type: "select",
      label: "Fuel Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 4,
        key: "sourceEFName5_2",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType5_2", eq: "Others" },
          { level: 2, key: "assetType5_2", notEmpty: true },
          { level: 3, key: "emissionSource5_2", eq: "Fuel" },
          { level: 3, key: "emissionSource5_2", notEmpty: true },
          {
            level: 4,
            key: "sourceEFName5_2",
            notEmpty: true,
          },
        ],
      },
      combineKey: 4,
    },
    //////// Fuel Name
    {
      key: "emissionFactorId",
      level: 7,
      type: "select",
      label: "Fuel Name",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 6,
        key: "fuelType5_2",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType5_2", eq: "Others" },
          { level: 2, key: "assetType5_2", notEmpty: true },
          { level: 3, key: "emissionSource5_2", eq: "Fuel" },
          { level: 3, key: "emissionSource5_2", notEmpty: true },
          {
            level: 6,
            key: "fuelType5_2",
            notEmpty: true,
          },
        ],
      },
      combineKey: 5,
    },
    //////// Emission Factor Database Source (Purchased Electricity)
    {
      key: "sourceEFName5_2",
      level: 4,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 3,
        key: "emissionSource5_2",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType5_2", eq: "Others" },
          { level: 2, key: "assetType5_2", notEmpty: true },
          { level: 3, key: "emissionSource5_2", eq: "Purchased Electricity" },
          { level: 3, key: "emissionSource5_2", notEmpty: true },
        ],
      },
      combineKey: 3,
    },
    //////// Location ( country ) (Purchased)
    {
      key: "location5_2",
      level: 6,
      type: "select",
      label: "Location ( Country )",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 4,
        key: "sourceEFName5_2",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType5_2", eq: "Others" },
          { level: 2, key: "assetType5_2", notEmpty: true },
          { level: 3, key: "emissionSource5_2", eq: "Purchased Electricity" },
          { level: 3, key: "emissionSource5_2", notEmpty: true },
          {
            level: 4,
            key: "sourceEFName5_2",
            notEmpty: true,
          },
        ],
      },
      combineKey: 4,
    },
    //////// State / City (Purchased)
    {
      key: "emissionFactorId",
      level: 7,
      type: "select",
      label: "State / City",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 6,
        key: "fuelType5_2",
      },
      showIf: {
        all: [
          { level: 2, key: "assetType5_2", eq: "Others" },
          { level: 2, key: "assetType5_2", notEmpty: true },
          { level: 3, key: "emissionSource5_2", eq: "Purchased Electricity" },
          { level: 3, key: "emissionSource5_2", notEmpty: true },
          {
            level: 6,
            key: "location5_2",
            notEmpty: true,
          },
        ],
      },
      combineKey: 5,
    },
    //////// 自定義 (非階層)
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 7,
      type: "select",
      custom: true,
      label: "Emission Factor Name",
      optionsAPI: "cat5CustomEFDropdownList",
      showIf: {
        level: 1,
        key: "emissionFactorTypeId",
        eq: "2",
      },
      autoFillNum: 0,
    },
    //////// 自定義 (Renewable Energy)
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 7,
      type: "select",
      custom: true,
      label: "Emission Factor Name",
      optionsAPI: "cat5CustomEFDropdownList",
      showIf: {
        all: [
          {
            level: 1,
            key: "emissionFactorTypeId",
            eq: "1",
          },
          { level: 2, key: "assetType5_2", eq: "Others" },
          { level: 2, key: "assetType5_2", notEmpty: true },
          { level: 3, key: "emissionSource5_2", eq: "Renewable Energy" },
          { level: 3, key: "emissionSource5_2", notEmpty: true },
        ],
      },
      autoFillNum: 0,
    },
  ],
};

export default threeThirteenSchema;
